import React from 'react'

// barrel file for loading states
import PropTypes from 'prop-types'
import AxisChartEmptyState from './AxisChartEmptyState.jsx'
import PieChartEmptyState from './PieChartEmptyState'
import GaugeEmptyState from './GaugeEmptyState'

const emptyStatesMap = {
  axis: AxisChartEmptyState,
  pie: PieChartEmptyState,
  gauge: GaugeEmptyState
}
const EmptyState = ({ type = 'pie', width, height = 300, ...emptyStateProps }) => {
  const Component = emptyStatesMap[type] ?? PieChartEmptyState
  return <Component {...emptyStateProps} width={width} height={height} />
}

EmptyState.propTypes = {
  type: PropTypes.string,
  width: PropTypes.number,
  height: PropTypes.number
}

export default EmptyState
